import emoji from "react-easy-emoji";

import vodalogo from "./assets/img/icons/common/voda.jpg";
import jclogo from "./assets/img/icons/common/johnson-controls.jpg";
import daiictlogo from "./assets/img/icons/common/daiict.png";
import awsCpLogo from './assets/img/icons/common/aws-cp.png';
import awsDaLogo from './assets/img/icons/common/aws-da.png';


export const greetings = {
	name: "Priyam Suthar",
	title: "Hello, I'm Priyam",
	description:
		"A passionate Software Engineer with a strong background and hands-on experience in domains like Software Architecture Design, Data Structure and Algorithms, Object Oriented Programming, Database Management Systems, Web Development, and Cloud Computing.",
	aboutMe: "I am a quick learner who loves solving challenging real-world problems. I like to think out of the box and am passionate about learning new tools and technologies.",
	resumeLink: "https://drive.google.com/file/d/11NwWuOy90kvlnz1Fv3ViHzlw9Cl1ewyG/view?usp=sharing",
};

export const openSource = {
	githubUserName: "pdsuthar10",
};

export const contact = {};

export const socialLinks = {	
	instagram: "https://www.instagram.com/lm1097",
	twitter: "https://twitter.com/pdsuthar10",
	github: "https://github.com/pdsuthar10",
	linkedin: "https://www.linkedin.com/in/pdsuthar10",
};

export const skillsSection = {
	title: "What I do",
	subTitle:
		"TECHNOLOGY ENTHUSIAST WHO IS ALWAYS KEEN ON LEARNING NEW TOOLS & TECHNOLOGIES",
	skills: [
		emoji(
			"⚡ Develop highly interactive Front end / User Interfaces for your web applications"
		),
		emoji(
			"⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"
		),
		emoji(
			"⚡ Integration of third party cloud services such as AWS"
		),
		emoji(
			"⚡ Build Robust and Scalable Backend Infrastructure"
		),
		emoji(
			"⚡ Strong written and verbal communication and interpersonal skills"
		),
		emoji(
			"⚡ Knowledge of professional software engineering and best practices for the full software development life cycle, including coding standards, code reviews, source control management, build processes, testing, and operations"
		),
	],

	softwareSkills: [
		{
			skillName: "Java",
			fontAwesomeClassname: "logos:java",
		},
		{
			skillName: "Spring",
			fontAwesomeClassname: "logos:spring-icon",
		},
		{
			skillName: "html-5",
			fontAwesomeClassname: "vscode-icons:file-type-html",
		},
		{
			skillName: "css3",
			fontAwesomeClassname: "vscode-icons:file-type-css",
		},
		{
			skillName: "sass",
			fontAwesomeClassname: "logos:sass",
		},
		{
			skillName: "JavaScript",
			fontAwesomeClassname: "logos:javascript",
		},
		{
			skillName: "TypeScript",
			fontAwesomeClassname: "logos:typescript-icon",
		},
		{
			skillName: "reactjs",
			fontAwesomeClassname: "vscode-icons:file-type-reactjs",
		},
		{
			skillName: "nodejs",
			fontAwesomeClassname: "logos:nodejs-icon",
		},		
		{
			skillName: "npm",
			fontAwesomeClassname: "vscode-icons:file-type-npm",
		},
		{
			skillName: "SQL",
			fontAwesomeClassname: "vscode-icons:file-type-sql",
		},
		{
			skillName: "MongoDB",
			fontAwesomeClassname: "vscode-icons:file-type-mongo",
		},
		{
			skillName: "AWS",
			fontAwesomeClassname: "logos:aws",
		},		
		{
			skillName: "Python",
			fontAwesomeClassname: "logos:python",
		},
		{
			skillName: "Git",
			fontAwesomeClassname: "logos:git-icon",
		},
		{
			skillName: "Docker",
			fontAwesomeClassname: "logos:docker-icon",
		},
		{
			skillName: "Hibernate",
			fontAwesomeClassname: "logos:hibernate",
		},
		{
			skillName: "Elasticsearch",
			fontAwesomeClassname: "logos:elasticsearch",
		},
		{
			skillName: "Redis",
			fontAwesomeClassname: "logos:redis",
		},
	],
};

export const SkillBars = [
	{
		Stack: "Software Development", //Insert stack or technology you have experience in
		progressPercentage: "90", //Insert relative proficiency in percentage
	},
	{
		Stack: "Frontend", //Insert stack or technology you have experience in
		progressPercentage: "90", //Insert relative proficiency in percentage
	},
	{
		Stack: "Backend",
		progressPercentage: "85",
	},
	{
		Stack: "Programming",
		progressPercentage: "90",
	},
];

export const educationInfo = [
	{
		schoolName: "Northeastern University",
		subHeader: "Master of Science in Information Systems",
		duration: "September 2019 - December 2021",
		desc: "Boston, Massachusetts, US",	
		courses: "Application Engineering Development, Program Structure and Algorithms, Network Structures and Cloud Computing, Web Tools & Development, Web Design & User Experience, Data Science Engineering Tools and Methods",
	},
	{
		schoolName: "Dhirubhai Ambani Institute of Information and Communication Technology",
		subHeader: "Bachelor of Technology in Information and Communication Technology",
		duration: "September 2015 - May 2019",
		desc: "Gandhinagar, Gujarat, IN",
		courses: "Operating Systems, Object Oriented Programming, Probability and Statistics, Bitcoin and Cryptocurrency",
	},
];

export const experience = [
	{
		role: "Full Stack Developer Intern",
		company: "VODA.ai",
		companylogo: vodalogo,
		date: "January 2021 - September 2021",
		desc: "Boston, Massachusetts, US",		
	},
	{
		role: "Research Intern",
		company: "DA-IICT",
		companylogo: daiictlogo,
		date: "January 2019 – May 2019",
		desc: "Gandhinagar, Gujarat, IN",
		backgroundColor: "rgb(10, 60, 130) none repeat scroll 0% 0%",
	},
	{
		role: "SDE Intern",
		company: "Johnson Controls",
		companylogo: jclogo,
		date: "May 2018 – October 2018",
		desc: "Mumbai, Maharashtra, IN",
	}
];

export const projects = [
	{
		name: "Big Data Indexing RESTful web application",
		desc: "January 2021 - April 2021",
		descBullets: [
			"Developed inverted index REST API application using Spring Boot, Redis and Elasticsearch",
			"Integrated Elasticsearch to perform indexed search functionality and demonstrated using Kibana tool",
			"Designed indexing of the JSON object to Elasticsearch via RabbitMQ queue, to run advanced search queries to retrieve the data",
		],
		github: "https://github.com/pdsuthar10/big-data-info7255",
	},
	{
		name: "Bug Tracking System - Bug Herd",
		desc: "October 2020 - December 2020",
		descBullets: [
			"Developed a full stack web application for users to easily record, assign and track bugs in a project following MVC architecture using Spring Framework",		
			"Implemented persistence layer using Custom DAOs, configured the POJOs with database tables using Hibernate to achieve associations, used HQL to query the database and performed CRUD operations",
		],
		github: "https://github.com/pdsuthar10/BugTrackingSystem",
	},
	{
		name: "DevOps Enhanced Web Application (AWS)",
		desc: "September 2020 - December 2020",
		descBullets: [
			"Designed fault-tolerant web application hosted on cloud computing platform (AWS) using NodeJS and Express",		
			"Created the cloud infrastructure for the application in Terraform, to support AWS Services like EC2, Lambda, S3, RDS, CloudWatch, IAM, VPC, Route53",			
		],
		github: "https://github.com/pdsuthar10/aws-webapp",	
	},
	{
		name: "Expert Hiring System",
		desc: "March 2020 - May 2020",
		descBullets: [
			"Deployed a mobile responsive website through Heroku that allows its users to hire an expert for home-based services such as plumbing, electronics repairing, and furniture cleaning",		
			"Shaped a single page web application using ReactJS, with MongoDB Atlas for database management along with Node.js in the backend and developed RESTful API services in an agile environment",			
		],
		github: "https://github.com/pdsuthar10/expertHiringSystem",	
		link: "https://expert-hiring-system.herokuapp.com/",
	},
	{
		name: "Web App for weather report",
		desc: "March 2020",
		descBullets: [
			"Created a responsive and dynamic Weather Forecast website using ReactJS and Materialize CSS in styling",		
			"Fetched data with API calls and added clickable functionality to change the temperature units",
			"Deployed and hosted the website on Heroku-app server",
		],
		github: "https://github.com/pdsuthar10/Weather-App",	
		link: "http://weather-app1097.herokuapp.com/",
	},
	{
		name: "Multi-Party NGO Software",
		desc: "October 2019 - December 2019",
		descBullets: [
			"Coded a multi-party work order software that connects the people, NGOs, hospitals and the government to better handle the social issues faced",		
			"Constructed client side components utilizing Java Swing framework",
			"Designed the system architecture along and assisted in creating the Object Model and Sequence Diagram",
		],
		github: "https://github.com/pdsuthar10/Multi-party-software-for-NGOs",	
	},
	{
		name: "Student Placement Cell Database Management",
		desc: "September 2017 - November 2017",
		descBullets: [
			"Led a three-person team in creating an illustrative sample of the database of Student Placement Cell",	
			"Included various placement related statistics, in PostgreSQL, covering most of the relevant functionalities required, with proper manipulation of data",				
		],
		github: "https://github.com/pdsuthar10/Student-Placement-Cell-Database-Management",	
	},
];

export const feedbacks = [
	{
		name: "Kosmas Karadimitriou",
		feedback:
			"Priyam is one of the best software developers. Although he joined our team as co-op, his performance, skills, maturity, and productivity matched or exceeded what I’d expect from full-time senior programmers. He delivered both in terms of quantity and quality, and I’d trust him to address any challenge and tackle any project. He’s responsive, trustworthy, and a true team player - you’d be lucky to have him in your team!",
	},
	{
		name: "Thanos Filippidis",
		feedback:
			"We worked with Priyam together at VODA.ai where he joined the team as a co-op. His performance though was far beyond the expected level, as he reached high standards of code quality and problem solving skills. He is a great team player with positive initiative and has excellent sense of time management, as he is committed to desired deadlines. I really enjoyed our co-operation and I am sure that he will boost up any programming team.",
	},
];


export const certificates = [
	{
		name: awsCpLogo,
		link:"https://drive.google.com/file/d/1qalK8bcgiSKtqpb6edQivZ1qVCb10bLh/view?usp=sharing",
	},
	{
		name: awsDaLogo,
		link:"https://drive.google.com/file/d/10H1uC1jspvaAQPrBT8z4aINh8gV3DqHc/view?usp=sharing",
	}


];